import React from 'react';
import { Link } from 'react-router-dom';
import { LoadingSpinner, EmptyState, Button, Badge } from '../ui';

/**
 * ReportsTab - Manage reported prompts
 */
const ReportsTab = ({ reportedPrompts, loading, onDismiss, onBan }) => {
  if (loading) {
    return <LoadingSpinner size="lg" text="Loading reported prompts..." />;
  }

  if (reportedPrompts.length === 0) {
    return (
      <EmptyState
        title="No reported prompts"
        message="Community reports will appear here for review."
      />
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold dark:text-white">Reported Prompts</h2>

      <div className="overflow-x-auto rounded-lg border dark:border-spooky-purple-mist">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-50 dark:bg-spooky-bg-light">
            <tr className="border-b dark:border-spooky-purple-mist">
              <th className="py-3 px-4 dark:text-white">Title</th>
              <th className="py-3 px-4 dark:text-white">Author</th>
              <th className="py-3 px-4 dark:text-white">Reports</th>
              <th className="py-3 px-4 dark:text-white">Status</th>
              <th className="py-3 px-4 dark:text-white">Hidden</th>
              <th className="py-3 px-4 dark:text-white">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y dark:divide-spooky-purple-mist">
            {reportedPrompts.map((prompt) => (
              <tr key={prompt.id} className="hover:bg-gray-50 dark:hover:bg-spooky-bg-light dark:text-white">
                <td className="py-3 px-4 max-w-xs">
                  <div className="font-semibold truncate">{prompt.title}</div>
                  <div className="text-xs text-gray-500 truncate">{prompt.description}</div>
                </td>
                <td className="py-3 px-4">@{prompt.username}</td>
                <td className="py-3 px-4">
                  <Badge variant={prompt.report_count >= 3 ? 'danger' : 'warning'}>
                    {prompt.report_count} {prompt.report_count === 1 ? 'report' : 'reports'}
                  </Badge>
                </td>
                <td className="py-3 px-4">
                  <Badge variant={prompt.status === 'banned' ? 'danger' : 'info'}>
                    {prompt.status}
                  </Badge>
                </td>
                <td className="py-3 px-4">
                  {prompt.is_hidden_by_reports ? (
                    <span className="text-red-600 dark:text-red-400 font-semibold">Yes</span>
                  ) : (
                    <span className="text-gray-500">No</span>
                  )}
                </td>
                <td className="py-3 px-4">
                  <div className="flex gap-2">
                    <Link
                      to={`/prompts/${prompt.id}`}
                      className="px-3 py-1 border dark:border-spooky-purple-mist rounded-lg text-xs hover:bg-gray-50 dark:hover:bg-spooky-bg-light"
                    >
                      View
                    </Link>
                    {prompt.status !== 'banned' && (
                      <>
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => onDismiss(prompt.id)}
                        >
                          Dismiss
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => onBan(prompt.id)}
                        >
                          Ban
                        </Button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportsTab;
